import { api } from './api';

export const constituencyService = {

    getConstituencies: async (pageNumber = 1, pageSize = 10, search = '') => {
        return api.get(`/constituency?PageNumber=${pageNumber}&PageSize=${pageSize}&Search=${search}`);
    },


    getConstituencyById: async (id) => {
        return api.get(`/constituency/${id}`);
    },

    /**
     *  Add  new constituency.
     */
    addConstituency: async (constituencyName) => {
        return api.post('/constituency', { constituencyName, isActive: true });
    },

    /**
     * Updates
     */
    updateConstituency: async (id, constituencyName, isActive = true) => {
        return api.post(`/constituency/${id}`, { constituencyName, isActive });
    },

    /**
     * Deletes
     */
    deleteConstituency: async (id) => {
        return api.delete(`/constituency/${id}`);
    }
};
